import React from "react";

export default function Footer() {
  return (
    <footer>
        <p>
            ©<a href="https://github.com/Sankti">Adam Goździelewski</a> 2020
        </p>
    </footer>
  );
}